import dispatcher from '../dispatcher';
import scrollStore from './scroll.store';
import resizeStore from '../resize/resize.store';

let topClass = 'top-direction';
let changeClass = 'absolute';

export class fixedArrowComponent extends HTMLElement {
    constructor() {
        super();

        this._bottom = document.querySelector('[data-fixed="bottom"]')


        this._onScroll();
        this.onScroll = (e) => this._onScroll(e);
    }

    connectedCallback() {
        window.addEventListener('scroll', this.onScroll);

    }

    disconnectedCallback() {
        window.removeEventListener('scroll', this.onScroll);
    }

    _onScroll() {
        const scrolled = scrollStore.getData().top;

        if (scrolled > 0) {
            this.classList.add(topClass)
        } else {
            this.classList.remove(topClass)
        }

        if (scrolled > this._bottom.offsetTop - resizeStore.getData().height) {
            this.classList.add(changeClass)
        } else {
            this.classList.remove(changeClass)
        }
    }
}


window.customElements.define('fixed-arrow', fixedArrowComponent);
